
<small><b> {{ refNumber + 1}} =  {{ aoDescription.description }} [ {{ aoDescription.department }} ] </b></small>
<kendo-lineargauge
  [pointer]="{ value: GetValue() }"
  [scale]="{ vertical: false, min: 0, max: 100 }"
>
</kendo-lineargauge>

<hr kendoCardSeparator />




